import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { IconWithLabelDisplay } from '../../components/iconWithLabelDisplay';
import { useAppSelector } from '../../redux/store';
import { ALL_BOMB_PROPERTIES } from '../../types/bombTypes';
import { BombButton } from './bombButton';
const CONTAINER_CSS = css `
  display: flex;
  flex-flow: row wrap;
  gap: 2px;
`;
export const TargetedBombButtonsContainer = ({ playerIdName }) => {
    const isSeatedPlayer = useAppSelector((state) => Object.values(state.poker.seatedPlayers).findIndex((seatedPlayer) => seatedPlayer?.id === playerIdName.id) !== -1);
    const isSelf = useAppSelector((state) => state.selfData.id === playerIdName.id);
    if (!isSeatedPlayer) {
        return _jsx(IconWithLabelDisplay, { label: `${playerIdName.name} is not sitting`, isSubtle: true });
    }
    return (_jsx("div", { css: CONTAINER_CSS, children: Object.values(ALL_BOMB_PROPERTIES).map((bombProperties, i) => (_jsx(BombButton, { bombProperties: bombProperties, username: playerIdName.name, isSelf: isSelf, mode: 'targeted' }, i))) }));
};
